
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/notifications",
      function () {
        return require("private-next-pages/user/notifications/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/notifications"])
      });
    }
  